<div class="app-bg">
  <header>
    <app-header></app-header>
  </header>
  <div class="app-container" [ngClass]="{
    'container': isContainerNormal(),
    'container-fluid': !isContainerNormal()}">
    <div class="row page-row mx-0">
      <div class="col-12 page-col px-0">
        <router-outlet></router-outlet>
        <app-loading-mask></app-loading-mask>
      </div>
    </div>
  </div>
  <footer>
    <app-footer></app-footer>
  </footer>
</div>
